import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "El primer encuentro",
    text: "Dicen que el amor llega cuando menos lo esperas. Para nosotros comenzó con una conversación que no queríamos terminar y una certeza silenciosa: algo había cambiado para siempre.",
    img: "/story/1.png",
    alt: "Jhonny y Emma junto al lago",
  },
  {
    n: "02",
    title: "La aventura comienza",
    text: "Después de incontables citas e increíbles momentos juntos, comenzamos a crear el hogar donde encontramos la paz y la seguridad que tanto necesitábamos. Entre risas, desafíos y nuevos recuerdos, construimos un lugar que hoy representa todo lo que somos y donde siempre queremos volver.",
    img: "/story/2.png",
    alt: "Jhonny y Emma en una cena",
  },
  {
    n: "03",
    title: "El sí para siempre",
    text: "Y llegó la pregunta que lo cambió todo. Dijimos sí — sí a la aventura, sí a los días grises y a los soleados, sí a nosotros. Ahora queremos celebrarlo contigo.",
    img: "/story/3.png",
    alt: "Jhonny y Emma besándose",
  },
];

export const OurStory = () => (
  <section id="historia" data-testid="our-story-section" className="relative py-28 md:py-40 px-6 bg-cream">
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <p className="font-script text-clay text-3xl md:text-4xl text-center">Nuestra Historia</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-center mt-3 text-ink">
          Capítulos de nosotros
        </h2>
      </Reveal>
      <div className="mt-24 space-y-28 md:space-y-40">
        {CHAPTERS.map((c, i) => (
          <div key={c.n} className="grid md:grid-cols-12 gap-10 md:gap-8 items-center">
            <Reveal
              className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2 md:col-start-8" : ""}`}
              delay={0.1}
            >
              <div className="relative">
                <div className="absolute inset-0 translate-x-4 translate-y-4 rounded-[2rem] border border-clay/25" />
                <div className={`relative overflow-hidden rounded-[2rem] ${i % 2 === 1 ? "rotate-[1.2deg]" : "rotate-[-1.2deg]"}`}>
                  <img
                    src={c.img}
                    alt={c.alt}
                    loading="lazy"
                    className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
            </Reveal>
            <Reveal
              className={`md:col-span-6 ${i % 2 === 1 ? "md:order-1 md:col-start-1" : "md:col-start-7"}`}
              delay={0.25}
            >
              <div className={i % 2 === 1 ? "md:text-right" : ""}>
                <span className="font-serif text-7xl md:text-8xl text-peach leading-none">{c.n}</span>
                <p className="mt-2 text-[11px] uppercase tracking-[0.35em] text-stone">Capítulo {c.n}</p>
                <h3 className="mt-4 font-serif text-3xl md:text-4xl text-ink tracking-tight">{c.title}</h3>
                <p className="mt-6 text-stone leading-relaxed text-sm md:text-base max-w-md inline-block">{c.text}</p>
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
);
